import { api_endpoint } from "../../config/environment";
import { strings } from "../../translations/strings";

const uploadFile = async (file) => {
  const endpoint = `${api_endpoint}ai/files`;
  const formData = new FormData();
  formData.append("file", file);
  const requestOptions = {
    method: "POST",
    body: formData,
  };
  try {
    const response = await fetch(endpoint, requestOptions);
    if (!response.ok) {
      if (response.status === 429) {
        throw new Error(strings.rate_limit_exceeded);
      } else {
        throw new Error();
      }
    }
    const data = await response.json();
    return data?.fileId;
  } catch (error) {
    throw error;
  }
};

const createThread = async (fileId) => {
  const endpoint = `${api_endpoint}ai/threads`;
  const payload = {
    messages: [
      {
        fileIds: [fileId],
        type: "pitch-deck-analyzer",
      },
    ],
  };
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  };
  try {
    const response = await fetch(endpoint, requestOptions);
    if (!response.ok) {
      throw new Error();
    }
    const data = await response.json();
    return data?.threadId;
  } catch (error) {
    throw new Error();
  }
};

const createRun = async (threadId) => {
  const endpoint = `${api_endpoint}ai/runs`;
  const formData = new FormData();
  formData.append("threadId", threadId);
  const requestOptions = {
    method: "POST",
    body: formData,
  };
  try {
    const response = await fetch(endpoint, requestOptions);
    if (!response.ok) {
      throw new Error();
    }
    const data = await response.json();
    return { threadId, runId: data?.runId };
  } catch (error) {
    throw new Error();
  }
};

const checkStatus = async ({ threadId, runId }) => {
  const endpoint = `${api_endpoint}ai/runs/${runId}/threads/${threadId}`;
  const requestOptions = {
    method: "GET",
  };
  try {
    let status = "pending";
    while (status !== "completed") {
      await new Promise((resolve) => setTimeout(resolve, 10000));
      const response = await fetch(endpoint, requestOptions);
      if (!response.ok) {
        return;
      }
      const data = await response.json();
      status = data?.status;
    }
  } catch (error) {
    throw new Error();
  }
};

const getResponse = async (threadId) => {
  const endpoint = `${api_endpoint}ai/threads/${threadId}/messages`;
  const requestOptions = {
    method: "GET",
  };
  try {
    const response = await fetch(endpoint, requestOptions);
    if (!response.ok) {
      throw new Error();
    }
    const data = await response.json();
    return data;
  } catch (error) {
    throw new Error();
  }
};

export { uploadFile, createThread, createRun, checkStatus, getResponse };
